import React, { useState, useEffect } from "react";
import { Col, Form, Row, Image } from "react-bootstrap";
import { OutlinedInput, FormControl } from "@material-ui/core";
import { ReusableOnboardingButton } from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ToggleButtonWithYesNo } from "../../../../AllButton/ToggleButtonReuse";
import { NewInputText } from "../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
//import { AddButtonIconComponent } from "../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { useFormik } from "formik";
import axios from "axios";
import {
  imageUploadSize,
  serverApi,
} from "../../../../../../../../config/Keys";
import { create_and_update_restaurant } from "../../../../../../../../store/actions/authAction";
import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { update_item_admin_menu_setup } from "../../../../../../../../store/actions/SuperAdminActions/adminCreateCatalogue";
import SingleImageReusableComponent from "../../../../../../../reusableComponents/imageUploadReusableComponent/SingleImageReusableComponent";

import SimpleReactLightbox from "simple-react-lightbox";

const validate = (values) => {
  const errors = {};

  // if (
  //   (values.nutritional_info && !values.calories.small.isDefault) ||
  //   !values.calories.medium.isDefault ||
  //   !values.calories.large.isDefault
  // ) {
  //   errors.isDefault = "Please select atleast one option";
  // }

  if (
    values.nutritional_info &&
    values.calories.small.isDefault &&
    !values.calories.small.calories
  ) {
    errors.small = "Please enter calories";
  }
  if (
    values.nutritional_info &&
    values.calories.medium.isDefault &&
    !values.calories.medium.calories
  ) {
    errors.medium = "Please enter calories";
  }

  if (
    values.nutritional_info &&
    values.calories.large.isDefault &&
    !values.calories.large.calories
  ) {
    errors.large = "Please enter calories";
  }

  if (values.details_nutritions.value && !values.details_nutritions.fats) {
    errors.fats = "Please enter fat";
  }

  if (values.details_nutritions.value && !values.details_nutritions.carbs) {
    errors.carbs = "Please enter carbohydrates";
  }

  if (values.details_nutritions.value && !values.details_nutritions.saturated) {
    errors.saturated = "Please enter saturated";
  }

  if (
    values.details_nutritions.value &&
    !values.details_nutritions.dietry_fibre
  ) {
    errors.dietry_fibre = "Please enter dietry fibre";
  }

  if (
    values.details_nutritions.value &&
    !values.details_nutritions.unsaturated
  ) {
    errors.unsaturated = "Please enter unsaturated";
  }

  if (
    values.details_nutritions.value &&
    !values.details_nutritions.total_sugar
  ) {
    errors.total_sugar = "Please enter total sugar";
  }

  if (
    values.details_nutritions.value &&
    !values.details_nutritions.cholestrol
  ) {
    errors.cholestrol = "Please enter cholestrol";
  }

  if (values.details_nutritions.value && !values.details_nutritions.sodium) {
    errors.sodium = "Please enter sodium";
  }

  if (values.details_nutritions.value && !values.details_nutritions.protein) {
    errors.protein = "Please enter protein";
  }

  return errors;
};

const NutritionAdmin = (props) => {
  const back = () => {
    props.onChange(1);
    window.scroll(0, 0);
  };
  const onClickBack = () => {
    let formData = {};
    const token = props.auth.user.accessToken;
    formData.currentState = 1;
    formData.runingTrack = 2;
    props.update_item_admin_menu_setup(
      props.activeItemId,
      formData,
      token,
      back
    );
  };

  const uploadImage = (e) => {
    const data = new FormData();
    data.append("files", e.target.files[0]);
    //setFile(URL.createObjectURL(e.target.files[0]));

    axios
      .post(`${serverApi}/upload-assets?uploadSide=nutritional`, data, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        //setFile(res.data[0]);
        //formik.setFieldValue("photos", res.data[0]);
        formik.setFieldValue(
          `details_nutritions.nutritional_image[0]`,
          res.data[0]
        );
      })
      .catch((err) => {
        Alert.error(`<h4>Error while uploading the image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      });
  };

  const removeImage = () => {
    formik.setFieldValue(`details_nutritions.nutritional_image[0]`, "");
  };

  const onChangeNutrionalInfo = () => {
    formik.setFieldValue("nutritional_info", !formik.values.nutritional_info);
  };

  const onChangeDetailsNutrutions = () => {
    formik.setFieldValue(
      "details_nutritions.value",
      !formik.values.details_nutritions.value
    );
  };

  const [count, setCount] = useState(1);

  const onClickNext = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    // if (formik.errors && formik.errors.small) {
    //   let smallElement = document.getElementById("small");
    //   smallElement.focus();
    // } else if (formik.errors && formik.errors.medium) {
    //   let mediumElement = document.getElementById("medium");
    //   mediumElement.focus();
    // } else if (formik.errors && formik.errors.large) {
    //   let largeElement = document.getElementById("large");
    //   largeElement.focus();
    if (formik.errors && formik.errors.fats) {
      let fatsElement = document.getElementById("fats");
      fatsElement.focus();
    } else if (formik.errors && formik.errors.carbs) {
      let carbsElement = document.getElementById("carbs");
      carbsElement.focus();
    } else if (formik.errors && formik.errors.saturated) {
      let saturatedElement = document.getElementById("saturated");
      saturatedElement.focus();
    } else if (formik.errors && formik.errors.dietry_fibre) {
      let dietry_fibreElement = document.getElementById("dietry_fibre");
      dietry_fibreElement.focus();
    } else if (formik.errors && formik.errors.unsaturated) {
      let unsaturatedElement = document.getElementById("unsaturated");
      unsaturatedElement.focus();
    } else if (formik.errors && formik.errors.total_sugar) {
      let total_sugarElement = document.getElementById("total_sugar");
      total_sugarElement.focus();
    } else if (formik.errors && formik.errors.cholestrol) {
      let cholestrolElement = document.getElementById("cholestrol");
      cholestrolElement.focus();
    } else if (formik.errors && formik.errors.sodium) {
      let sodiumElement = document.getElementById("sodium");
      sodiumElement.focus();
    } else if (formik.errors && formik.errors.protein) {
      let proteinElement = document.getElementById("protein");
      proteinElement.focus();
    }
  }, [count]);

  const onSuccess = () => {
    props.onChange(8);
    window.scroll(0, 0);
  };

  const onChangeCalDefault = (size) => {
    if (size === "small") {
      formik.setFieldValue("calories.small.isDefault", true);
    } else {
      formik.setFieldValue("calories.small.isDefault", false);
    }
    if (size === "medium") {
      formik.setFieldValue("calories.medium.isDefault", true);
    } else {
      formik.setFieldValue("calories.medium.isDefault", false);
    }
    if (size === "large") {
      formik.setFieldValue("calories.large.isDefault", true);
    } else {
      formik.setFieldValue("calories.large.isDefault", false);
    }
  };

  const formik = useFormik({
    initialValues: {
      nutritional_info: false,
      calories: {
        small: {
          isDefault: true,
          calories: "",
        },
        medium: {
          isDefault: false,
          calories: "",
        },
        large: {
          isDefault: false,
          calories: "",
        },
      },
      details_nutritions: {
        value: false,
        fats: "0.1",
        carbs: "0.1",
        saturated: "0.1",
        dietry_fibre: "0.1",
        unsaturated: "0.1",
        total_sugar: "0.1",
        cholestrol: "0.1",
        sodium: "0.1",
        protein: "0.1",
        info_text: "info for nutritions",
        nutritional_image: [],
      },
    },
    validate,

    onSubmit: (values) => {
      // props.onChange(8);
      //window.scroll(0, 0);
      let formData = {};
      formData = { ...formik.values };
      const token = props.auth.user.accessToken;

      formData.currentState = 2;
      formData.runingTrack = 3;
      props.update_item_admin_menu_setup(
        props.activeItemId,
        formData,
        token,
        onSuccess
      );
    },
  });

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;
      if (data && data.calories) {
        formik.setFieldValue("calories", data.calories);
      }

      formik.setFieldValue("nutritional_info", data.nutritional_info);

      formik.setFieldValue(
        "details_nutritions.value",
        data.details_nutritions.value
      );

      formik.setFieldValue(
        "details_nutritions.fats",
        data.details_nutritions.fats
      );
      formik.setFieldValue(
        "details_nutritions.carbs",
        data.details_nutritions.carbs
      );
      formik.setFieldValue(
        "details_nutritions.saturated",
        data.details_nutritions.saturated
      );
      formik.setFieldValue(
        "details_nutritions.dietry_fibre",
        data.details_nutritions.dietry_fibre
      );
      formik.setFieldValue(
        "details_nutritions.unsaturated",
        data.details_nutritions.unsaturated
      );
      formik.setFieldValue(
        "details_nutritions.total_sugar",
        data.details_nutritions.total_sugar
      );
      formik.setFieldValue(
        "details_nutritions.cholestrol",
        data.details_nutritions.cholestrol
      );
      formik.setFieldValue(
        "details_nutritions.sodium",
        data.details_nutritions.sodium
      );
      formik.setFieldValue(
        "details_nutritions.protein",
        data.details_nutritions.protein
      );
      formik.setFieldValue(
        "details_nutritions.info_text",
        data.details_nutritions.info_text
      );
      formik.setFieldValue(
        "details_nutritions.nutritional_image",
        data.details_nutritions.nutritional_image
      );
    }
  }, [props.menuCategoryItems]);
  const [logo_url, setLogoUrl] = useState(null);
  const [combined, setCombined] = useState(null);
  const [logo_main, setLogoMain] = useState(null);
  const onCompleteCrop = (url) => {
    setLogoUrl(url);
    formik.setFieldValue(`details_nutritions.nutritional_image[0]`, url);
    onCancelCrop();
  };

  const onCancelCrop = () => {
    setLogoMain("");
  };

  const onImageLogoUploadHandler = (e) => {
    try {
      // this.setState({ singleImageLoader: true });
      // if (e.target.files) {
      // console.log(e.target.files, this.state);
      const vendor_id = props.auth.user.VendorUser._id;
      const restaurant_name = props.onboarding.restaurant_name
        .split(" ")
        .join("");
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      data.append("files", e.target.files[0]);
      if (e.target.files[0].size > imageUploadSize) {
        alert("File is too Big");
      } else {
        setLogoMain(e.target.files[0]);
        setCombined(combined);
      }
      e.target.value = "";
    } catch (err) {
      console.log(err);
    }
    // }
  };

  const removeFile = () => {
    setLogoUrl(null);
    formik.setFieldValue(`details_nutritions.nutritional_image[0]`, "");
  };
  return (
    <React.Fragment>
      <Form className="mobile-pb-50">
        <div className="mb-4">
          <TopTextReusableComponent
            headingText="New Item"
            headingParagraph="Manage your food items"
          />
        </div>
        <div className="bg-gray px-3 py-2">
          <Row>
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="f12-700 pr-3" style={{ width: 140 }}>
                  Ext Item ID :
                </div>
                <FormControl className={"w-100 bg-white"} variant="outlined">
                  <OutlinedInput
                    disabled
                    value={
                      props.menuCategoryItems && props.menuCategoryItems.ext_id
                    }
                  />
                </FormControl>
              </div>
            </Col>
          </Row>
        </div>
        <div
          className="displayItemsName f11-400 enRadius5 my-4"
          style={{ height: 50 }}
        >
          {props.menuCategoryItems && props.menuCategoryItems.name}
        </div>
        {/* <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
          <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
            Nutritional Information
          </div>
          <div className="col-4 col-md-4 col-lg-6">
            <ToggleButtonWithYesNo
              checkedBox={formik.values.nutritional_info}
              onChange={() => onChangeNutrionalInfo()}
            />
          </div>
        </div>
        {formik.values.nutritional_info ? (
          <>
            <Row>
              <Col lg={12}>
                <div className="opacity5 f12-400 pb-3">
                  Enter calorie information
                </div>
              </Col>
              <Col xs={2} xl={2}>
                <div className="f12-500 mobile-f10-400">Set Default</div>
              </Col>
              <Col xs={4} xl={3}>
                <div className="f12-500 mobile-f10-400">Size Description</div>
              </Col>
              <Col xs={6} xl={4}>
                <div className="f12-500 mobile-f10-400">Calories</div>
              </Col>
              <Col lg={12}>
                <Row className="align-items-center py-2">
                  <Col xs={2} xl={2}>
                    <label className="enRadioWithText small mr-3">
                      <input
                        type="radio"
                        name="calories.isDefault"
                        checked={formik.values.calories.small.isDefault}
                        onChange={() => onChangeCalDefault("small")}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </Col>
                  <Col xs={4} xl={3}>
                    <div className="f14-700">Small</div>
                  </Col>
                  <Col xs={6} xl={4}>
                    <div className="d-flex align-items-center">
                      <NewInputText
                        controlClass={"small"}
                        placeholder="value"
                        inputType="number"
                        extraClass={`mb-1 w-100 ${
                          formik.errors.small &&
                          formik.touched &&
                          formik.touched.calories &&
                          formik.touched.calories.small &&
                          formik.touched.calories.small.calories
                            ? "enError"
                            : ""
                        }`}
                        name="calories.small.calories"
                        onChange={formik.handleChange}
                        value={formik.values.calories.small.calories}
                        onFocusOut={formik.handleBlur}
                      />
                      <Image
                        src={require("../../../../../../../../assets/images/UserManagement/information.svg")}
                        alt="information"
                        title="information"
                        className="ml-2"
                      />
                    </div>
                    {formik.errors.small &&
                    formik.touched &&
                    formik.touched.calories &&
                    formik.touched.calories.small &&
                    formik.touched.calories.small.calories ? (
                      <div className="pho_14_regular  text-danger">
                        {formik.errors.small}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row className="align-items-center py-2">
                  <Col xs={2} xl={2}>
                    <label className="enRadioWithText small mr-3">
                      <input
                        type="radio"
                        name="calories.isDefault"
                        checked={formik.values.calories.medium.isDefault}
                        onChange={() => onChangeCalDefault("medium")}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </Col>
                  <Col xs={4} xl={3}>
                    <div className="f14-700">Medium</div>
                  </Col>
                  <Col xs={6} xl={4}>
                    <div className="d-flex align-items-center">
                      <NewInputText
                        controlClass={"medium"}
                        placeholder="value"
                        inputType="number"
                        extraClass={`mb-1 w-100 ${
                          formik.errors.medium &&
                          formik.touched &&
                          formik.touched.calories &&
                          formik.touched.calories.medium &&
                          formik.touched.calories.medium.calories
                            ? "enError"
                            : ""
                        }`}
                        name="calories.medium.calories"
                        onChange={formik.handleChange}
                        value={formik.values.calories.medium.calories}
                        onFocusOut={formik.handleBlur}
                      />
                      <Image
                        src={require("../../../../../../../../assets/images/UserManagement/information.svg")}
                        alt="information"
                        title="information"
                        className="ml-2"
                      />
                    </div>
                    {formik.errors.medium &&
                    formik.touched &&
                    formik.touched.calories &&
                    formik.touched.calories.medium &&
                    formik.touched.calories.medium.calories ? (
                      <div className="pho_14_regular  text-danger">
                        {formik.errors.medium}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row className="align-items-center py-2">
                  <Col xs={2} xl={2}>
                    <label className="enRadioWithText small mr-3">
                      <input
                        type="radio"
                        name="calories.isDefault"
                        checked={formik.values.calories.large.isDefault}
                        onChange={() => onChangeCalDefault("large")}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </Col>
                  <Col xs={4} xl={3}>
                    <div className="f14-700">Large</div>
                  </Col>
                  <Col xs={6} xl={4}>
                    <div className="d-flex align-items-center">
                      <NewInputText
                        controlClass={"large"}
                        placeholder="value"
                        inputType="number"
                        extraClass={`mb-1 w-100 ${
                          formik.errors.large &&
                          formik.touched &&
                          formik.touched.calories &&
                          formik.touched.calories.large &&
                          formik.touched.calories.large.calories
                            ? "enError"
                            : ""
                        }`}
                        name="calories.large.calories"
                        onChange={formik.handleChange}
                        value={formik.values.calories.large.calories}
                        onFocusOut={formik.handleBlur}
                      />
                      <Image
                        src={require("../../../../../../../../assets/images/UserManagement/information.svg")}
                        alt="information"
                        title="information"
                        className="ml-2"
                      />
                    </div>
                    {formik.errors.large &&
                    formik.touched &&
                    formik.touched.calories &&
                    formik.touched.calories.large &&
                    formik.touched.calories.large.calories ? (
                      <div className="pho_14_regular  text-danger">
                        {formik.errors.large}
                      </div>
                    ) : null}
                  </Col>
                </Row>
              </Col>
            </Row>
            {formik.errors.calories && formik.touched.calories ? (
              <div className="pho_14_regular mb-3 text-danger">
                {formik.errors.calories}
              </div>
            ) : (
              <div className="mb-3"></div>
            )}
          </>
        ) : (
          <> </>
        )} */}
        <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
          <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
            Details nutrition info for this item available as in product label ?
          </div>
          <div className="col-4 col-md-4 col-lg-6">
            <div className="new-subscription-onboarding-component">
              <ToggleButtonWithYesNo
                activeClass={formik.values.details_nutritions.value}
                checkedBox={formik.values.details_nutritions.value}
                onChange={() => onChangeDetailsNutrutions()}
                // disabled={disabled}
              />
            </div>
          </div>
        </div>
        {formik.values.details_nutritions.value ? (
          <>
            <Row>
              <Col xs={6} md={5}>
                <NewInputText
                  controlClass={"fats"}
                  labelText="Fats"
                  inputType="number"
                  extraClass={`mb-1 w-100 ${
                    formik.errors.fats &&
                    formik.touched &&
                    formik.touched.details_nutritions &&
                    formik.touched.details_nutritions.fats
                      ? "enError"
                      : ""
                  }`}
                  name="details_nutritions.fats"
                  onChange={formik.handleChange}
                  value={formik.values.details_nutritions.fats}
                  onFocusOut={formik.handleBlur}
                />
                {formik.errors.fats &&
                formik.touched &&
                formik.touched.details_nutritions &&
                formik.touched.details_nutritions.fats ? (
                  <div className="pho_14_regular mb-3 text-danger">
                    {formik.errors.fats}
                  </div>
                ) : (
                  <div className="mb-3"></div>
                )}
              </Col>

              <Col xs={6} md={5}>
                <NewInputText
                  controlClass={"carbs"}
                  labelText="Carbohydrates"
                  inputType="number"
                  extraClass={`mb-1 w-100 ${
                    formik.errors.carbs &&
                    formik.touched &&
                    formik.touched.details_nutritions &&
                    formik.touched.details_nutritions.carbs
                      ? "enError"
                      : ""
                  }`}
                  name="details_nutritions.carbs"
                  onChange={formik.handleChange}
                  value={formik.values.details_nutritions.carbs}
                  onFocusOut={formik.handleBlur}
                />
                {formik.errors.carbs &&
                formik.touched &&
                formik.touched.details_nutritions &&
                formik.touched.details_nutritions.carbs ? (
                  <div className="pho_14_regular mb-3 text-danger">
                    {formik.errors.carbs}
                  </div>
                ) : (
                  <div className="mb-3"></div>
                )}
              </Col>

              <Col xs={6} md={5}>
                <NewInputText
                  controlClass={"saturated"}
                  labelText="Saturated"
                  inputType="number"
                  extraClass={`mb-1 w-100 ${
                    formik.errors.saturated &&
                    formik.touched &&
                    formik.touched.details_nutritions &&
                    formik.touched.details_nutritions.saturated
                      ? "enError"
                      : ""
                  }`}
                  name="details_nutritions.saturated"
                  onChange={formik.handleChange}
                  value={formik.values.details_nutritions.saturated}
                  onFocusOut={formik.handleBlur}
                />
                {formik.errors.saturated &&
                formik.touched &&
                formik.touched.details_nutritions &&
                formik.touched.details_nutritions.saturated ? (
                  <div className="pho_14_regular mb-3 text-danger">
                    {formik.errors.saturated}
                  </div>
                ) : (
                  <div className="mb-3"></div>
                )}
              </Col>
              <Col xs={6} md={5}>
                <NewInputText
                  controlClass={"dietry_fibre"}
                  labelText="Dietary Fibers"
                  inputType="number"
                  extraClass={`mb-1 w-100 ${
                    formik.errors.dietry_fibre &&
                    formik.touched &&
                    formik.touched.details_nutritions &&
                    formik.touched.details_nutritions.dietry_fibre
                      ? "enError"
                      : ""
                  }`}
                  name="details_nutritions.dietry_fibre"
                  onChange={formik.handleChange}
                  value={formik.values.details_nutritions.dietry_fibre}
                  onFocusOut={formik.handleBlur}
                />
                {formik.errors.dietry_fibre &&
                formik.touched &&
                formik.touched.details_nutritions &&
                formik.touched.details_nutritions.dietry_fibre ? (
                  <div className="pho_14_regular mb-3 text-danger">
                    {formik.errors.dietry_fibre}
                  </div>
                ) : (
                  <div className="mb-3"></div>
                )}
              </Col>

              <Col xs={6} md={5}>
                <NewInputText
                  controlClass={"unsaturated"}
                  labelText="Unsaturated"
                  inputType="number"
                  extraClass={`mb-1 w-100 ${
                    formik.errors.unsaturated &&
                    formik.touched &&
                    formik.touched.details_nutritions &&
                    formik.touched.details_nutritions.unsaturated
                      ? "enError"
                      : ""
                  }`}
                  name="details_nutritions.unsaturated"
                  onChange={formik.handleChange}
                  value={formik.values.details_nutritions.unsaturated}
                  onFocusOut={formik.handleBlur}
                />
                {formik.errors.unsaturated &&
                formik.touched &&
                formik.touched.details_nutritions &&
                formik.touched.details_nutritions.unsaturated ? (
                  <div className="pho_14_regular mb-3 text-danger">
                    {formik.errors.unsaturated}
                  </div>
                ) : (
                  <div className="mb-3"></div>
                )}
              </Col>
              <Col xs={6} md={5}>
                <NewInputText
                  controlClass={"total_sugar"}
                  labelText="Total Sugars"
                  inputType="number"
                  extraClass={`mb-1 w-100 ${
                    formik.errors.total_sugar &&
                    formik.touched &&
                    formik.touched.details_nutritions &&
                    formik.touched.details_nutritions.total_sugar
                      ? "enError"
                      : ""
                  }`}
                  name="details_nutritions.total_sugar"
                  onChange={formik.handleChange}
                  value={formik.values.details_nutritions.total_sugar}
                  onFocusOut={formik.handleBlur}
                />
                {formik.errors.total_sugar &&
                formik.touched &&
                formik.touched.details_nutritions &&
                formik.touched.details_nutritions.total_sugar ? (
                  <div className="pho_14_regular mb-3 text-danger">
                    {formik.errors.total_sugar}
                  </div>
                ) : (
                  <div className="mb-3"></div>
                )}
              </Col>
              <Col xs={6} md={5}>
                <NewInputText
                  controlClass={"cholestrol"}
                  labelText="Cholestrol"
                  inputType="number"
                  extraClass={`mb-1 w-100 ${
                    formik.errors.cholestrol &&
                    formik.touched &&
                    formik.touched.details_nutritions &&
                    formik.touched.details_nutritions.cholestrol
                      ? "enError"
                      : ""
                  }`}
                  name="details_nutritions.cholestrol"
                  onChange={formik.handleChange}
                  value={formik.values.details_nutritions.cholestrol}
                  onFocusOut={formik.handleBlur}
                />
                {formik.errors.cholestrol &&
                formik.touched &&
                formik.touched.details_nutritions &&
                formik.touched.details_nutritions.cholestrol ? (
                  <div className="pho_14_regular mb-3 text-danger">
                    {formik.errors.cholestrol}
                  </div>
                ) : (
                  <div className="mb-3"></div>
                )}
              </Col>
              <Col xs={6} md={5}>
                <NewInputText
                  controlClass={"sodium"}
                  labelText="Sodium"
                  inputType="number"
                  extraClass={`mb-1 w-100 ${
                    formik.errors.sodium &&
                    formik.touched &&
                    formik.touched.details_nutritions &&
                    formik.touched.details_nutritions.sodium
                      ? "enError"
                      : ""
                  }`}
                  name="details_nutritions.sodium"
                  onChange={formik.handleChange}
                  value={formik.values.details_nutritions.sodium}
                  onFocusOut={formik.handleBlur}
                />
                {formik.errors.sodium &&
                formik.touched &&
                formik.touched.details_nutritions &&
                formik.touched.details_nutritions.sodium ? (
                  <div className="pho_14_regular mb-3 text-danger">
                    {formik.errors.sodium}
                  </div>
                ) : (
                  <div className="mb-3"></div>
                )}
              </Col>
              <Col xs={6} md={5}>
                <NewInputText
                  controlClass={"protein"}
                  labelText="Proteins"
                  inputType="number"
                  extraClass={`mb-1 w-100 ${
                    formik.errors.protein &&
                    formik.touched &&
                    formik.touched.details_nutritions &&
                    formik.touched.details_nutritions.protein
                      ? "enError"
                      : ""
                  }`}
                  name="details_nutritions.protein"
                  onChange={formik.handleChange}
                  value={formik.values.details_nutritions.protein}
                  onFocusOut={formik.handleBlur}
                />
                {formik.errors.protein &&
                formik.touched &&
                formik.touched.details_nutritions &&
                formik.touched.details_nutritions.protein ? (
                  <div className="pho_14_regular mb-3 text-danger">
                    {formik.errors.protein}
                  </div>
                ) : (
                  <div className="mb-3"></div>
                )}
              </Col>
              {/* <Col md={5}>
                <AddButtonIconComponent
                  buttonText="Suggest New"
                  fontIcon="fa fa-plus"
                  colorCss="red"
                />
              </Col> */}
              <Col md={10}>
                <NewInputText
                  labelText="Nutrition Info Additional Text"
                  extraClass="mb-4 w-100"
                  multiline={true}
                  rows="5"
                  name="details_nutritions.info_text"
                  onChange={formik.handleChange}
                  value={formik.values.details_nutritions.info_text}
                />
              </Col>
            </Row>
            <Form.Group className="py-4">
              <SimpleReactLightbox>
                <SingleImageReusableComponent
                  title="Nutrition Info Image"
                  // smallTitle="( You can upload only 1 pic per offer 700 x 420 pixels )"
                  // onDrop={this.onSingleImageDrop}
                  onChange={onImageLogoUploadHandler}
                  combined={combined}
                  onCompleteCrop={onCompleteCrop}
                  onCancelCrop={onCancelCrop}
                  file={logo_main !== "" ? logo_main : logo_url}
                  resetFile={removeFile}
                  name="logo_url"
                  // error={errors.logo_url}
                  // loader={this.state.singleImageLoader}
                />
                <div className="font_12_r c_gray mb-4 mt-3">
                  Only .jpg and .png files. 500kb max file size
                </div>
              </SimpleReactLightbox>
              {/* <Form.Label className="f14-500 mb-1">
                Nutrition Info Image
              </Form.Label>
              
              <div className="d-flex flex-wrap">
                <div className="enUploadBox">
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/uploadImg.svg")}
                    alt="uploadImg"
                    title="uploadImg"
                    fluid
                  />
                  <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    onChange={uploadImage}
                  />
                </div>
                {formik.values &&
                formik.values.details_nutritions.nutritional_image[0] ? (
                  <div className="enIconUploaded">
                    <button
                      type="button"
                      className="enCloseButton"
                      onClick={() => removeImage()}
                    >
                      <Image
                        src={require("../../../../../../../../assets/images/UserManagement/en_close.svg")}
                        alt="uploadImg"
                        title="uploadImg"
                        fluid
                      />
                    </button>
                    <Image
                      src={
                        formik.values.details_nutritions.nutritional_image[0]
                      }
                      alt="icon"
                      title="icon"
                      className=""
                      fluid
                    />
                  </div>
                ) : (
                  <> </>
                )}
              </div> */}
            </Form.Group>
          </>
        ) : (
          <> </>
        )}

        <div className="onboarding-map-setup-screen-autodetect-button mt-5">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="btn-lg btn btn-outline-secondary"
            buttonText="Back"
            buttonType="button"
            onClick={() => onClickBack()}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
            buttonText="Save and Next"
            buttonType="button"
            //onClick={onSubmit}
            onClick={(e) => onClickNext(e)}
          />
        </div>
      </Form>
    </React.Fragment>
  );
};

NutritionAdmin.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_admin_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  menuCategoryItems: state.commonSuperAdmin.menuCategoryItems,
  activeItemId: state.commonSuperAdmin.activeItemId,
});

export default connect(mapStateToProps, {
  update_item_admin_menu_setup,
  create_and_update_restaurant,
})(NutritionAdmin);
